import React from 'react';

const Logo = () => {
    return (
        
            <img className='logo'  src="/ban2.jpeg" alt="" />
        
    );
};

export default Logo;